export default "__VITE_ASSET__DwvTqiDW__"